import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("enrollmentAgreements", {
  slugs: (productSlug: string) => ({
    queryKey: [productSlug],
  }),
})
